import { RatingStatus } from '../enums/rating-status.enum';
import { RatingType } from '../enums/rating-type.enum';
import { RatingAnswer } from './rating-answer.model';

export class Rating {
  id: number;
  type: RatingType;
  star: number;
  comment: string;
  dateTimeRate: number;
  dateTimePublish: number;
  userId: number;
  userName: string;
  userEmail: string;
  establishmentId: number;
  establishmentName: string;
  establihmentTradeName: string;
  productId: number;
  productName: string;
  productDescription: string;
  status: RatingStatus;
  answers: Array<RatingAnswer>;
  orderId: number;
  orderNumber: string;

  // Aux para construir tela de avaliações do pedido
  stars?: Array<any>;

  constructor(obj: any = {}) {
    Object.assign(this, obj);

    if (!this.answers) {
      this.answers = new Array();
    }
  }
}

export interface RatingsResponse {
  ratings: Array<Rating>;
  count: number;
}



// WEBPACK FOOTER //
// ./src/app/pages/rating/models/rating.model.ts